export const ADD_INGREDIENTS = 'ADD_INGREDIENTS';
export const SAVE_TOKEN = 'SAVE_FIREBASE_TOKEN';
export const SAVE_USER = 'SAVE_USER';
export const GET_USER = 'GET_USER';